import {AppState} from './../../../store';
import {createSelector} from 'reselect';

export const selectedPlacesSelector = (state: AppState) => state.maps?.selectedPlaces || null;
export const showAllPlacesSelector = (state: AppState) => state.maps?.showAllPlaces || false;
